/**
 * SEO utility functions for dynamic meta tag management
 */

/**
 * Updates the document title
 * @param {string} title - Page title
 * @param {string} siteName - Site name (optional)
 */
export const updateTitle = (title, siteName = 'Mahanoor Syed') => {
  document.title = title ? `${title} | ${siteName}` : siteName;
};

/**
 * Updates meta tags
 * @param {Object} metaTags - Object containing meta tag properties
 */
export const updateMetaTags = (metaTags) => {
  const {
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    twitterCard = 'summary',
    twitterTitle,
    twitterDescription,
    twitterImage,
  } = metaTags;

  // Update or create description meta tag
  updateOrCreateMetaTag('description', description);
  
  // Update or create keywords meta tag
  if (keywords) {
    updateOrCreateMetaTag('keywords', keywords);
  }

  // Open Graph tags
  if (ogTitle) updateOrCreateMetaTag('og:title', ogTitle, 'property');
  if (ogDescription) updateOrCreateMetaTag('og:description', ogDescription, 'property');
  if (ogImage) updateOrCreateMetaTag('og:image', ogImage, 'property');
  if (ogUrl) updateOrCreateMetaTag('og:url', ogUrl, 'property');

  // Twitter Card tags
  updateOrCreateMetaTag('twitter:card', twitterCard, 'name');
  if (twitterTitle) updateOrCreateMetaTag('twitter:title', twitterTitle, 'name');
  if (twitterDescription) updateOrCreateMetaTag('twitter:description', twitterDescription, 'name');
  if (twitterImage) updateOrCreateMetaTag('twitter:image', twitterImage, 'name');
};

/**
 * Helper function to update or create a meta tag
 * @param {string} name - Meta tag name or property
 * @param {string} content - Meta tag content
 * @param {string} attribute - Attribute type ('name' or 'property')
 */
const updateOrCreateMetaTag = (name, content, attribute = 'name') => {
  if (!content) return;

  let metaTag = document.querySelector(`meta[${attribute}="${name}"]`);
  
  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute(attribute, name);
    document.head.appendChild(metaTag);
  }
  
  metaTag.setAttribute('content', content);
};

/**
 * Sets canonical URL
 * @param {string} url - Canonical URL
 */
export const setCanonicalUrl = (url) => {
  let link = document.querySelector('link[rel="canonical"]');
  
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  
  link.setAttribute('href', url);
};

